<template>
  <RouterView />
</template>

<script lang="ts">
import { useLayoutStore } from '@/stores/layout'
import { setupApp } from '@/typings/Helpers'
import { onMounted, defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const useLayout = useLayoutStore()

    const initPortletCard = () => {
      const portletIdentifier = '.card'
      const portletCloser = '.card a[data-bs-toggle="remove"]'
      const portletRefresher = '.card a[data-bs-toggle="reload"]'

      // Panel close handler
      $(document).on('click', portletCloser, function (ev) {
        ev.preventDefault()
        const $portlet = $(this).closest(portletIdentifier)
        const $portletParent = $portlet.parent()
        $portlet.remove()
        if ($portletParent.children().length === 0) {
          $portletParent.remove()
        }
      })

      // Panel reload handler
      $(document).on('click', portletRefresher, function (ev) {
        ev.preventDefault()
        const $portlet = $(this).closest(portletIdentifier)
        $portlet.append('<div class="card-disabled"><div class="card-portlets-loader"></div></div>')
        const $pd = $portlet.find('.card-disabled')
        setTimeout(
          () => {
            $pd.fadeOut('fast', () => {
              $pd.remove()
            })
          },
          500 + 300 * (Math.random() * 5),
        )
      })
    }

    onMounted(() => {
      useLayout.init()
      useLayout.initConfig()

      initPortletCard()

      // Set up version refresh
      setInterval(() => {
        setupApp()
      }, 300000)
    })

    return {
      useLayout,
    }
  },
})
</script>
